

import React from 'react';

const ClientsSection: React.FC = () => {
  const clients = Array.from({ length: 26 }, (_, i) => ({
    id: i + 1,
    src: `/images/logos_empresas/${i + 1}.png`,
    alt: `Cliente ${i + 1}`
  }));

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Alguns <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-500">Clientes</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Marcas que confiam na <strong>M4 Digital</strong> e estão <strong>acelerando suas vendas</strong> com nossas estratégias de alta performance
          </p>
        </div>

        {/* Clients Grid */}
        <div className="relative">
          {/* Background decoration */}
          <div className="absolute inset-0 bg-gradient-to-r from-orange-100/20 via-transparent to-red-100/20 rounded-3xl"></div>
          
          <div className="relative bg-white/80 backdrop-blur-sm rounded-3xl p-8 lg:p-12 shadow-xl border border-gray-100">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-8 lg:gap-12">
              {clients.map((client) => (
                <div
                  key={client.id}
                  className="group flex items-center justify-center p-4 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 border border-gray-100"
                >
                  <img
                    src={client.src}
                    alt={client.alt}
                    className="max-w-full max-h-16 w-auto h-auto object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300 opacity-70 group-hover:opacity-100"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom text */}
        <div className="text-center mt-12">
          <p className="text-lg text-gray-500 font-medium">
            + de <span className="text-orange-600 font-bold">1.200 empresas</span> já transformaram seus resultados conosco
          </p>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;

